export default __webpack_public_path__ + "static/media/icon-cal-circle-solid.39b8ae47.svg";